import { clubsApi } from "@apiService";
import * as types from "./types";

export const getClubsData = (slug) => {
  return {
    type: types.GET_CLUBS_DATA,
    payload: clubsApi.getClubss(slug),
  };
};
